import styled from "styled-components";

export const ContainerHeader = styled.div`
    display: flex;
    flex-direction: column;
    border-radius: 4px;
    border: 1px solid #D8DCDE;
    background-color: white;
`

export const ContainerOptionsCreate = styled.nav`
    display: flex;
    gap: 10px;
    margin-bottom: -25px;

    p{
        padding: 10px 24px;
        color: #6B7177;
        font-size: 14px;
        cursor: pointer;

        &:hover, &.active{
            color: #2F5BFF;
            border-bottom: 3px solid #2F5BFF;
            font-weight: 600;
        }
    }

    p.disabled {
      cursor: not-allowed;
      color: #9ca3af;
    }

`

export const ContainerTitle = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #D8DCDE;
    padding: 16px 24px;

    h1{
        color: #414141;
        font-size: 24px;
        font-weight: 500;
    }
`

export const ContainerDownload = styled.div`
    display: flex;
    justify-content: end;
    border-top: 1px solid #D8DCDE;
    padding: 16px 24px;
`